export const dropdownData = [
  {
    id: 1,
    name: "Electronics",
    subCategoryTitle: "Electronics,Photo & Video",
    subCategories: [
      {
        children: [
          { id: 1, name: "Digital Cameras", quantity: 100 },
          { id: 2, name: "Compact Interchangeable Lens", quantity: 2 },
          { id: 3, name: "Compact Point & Shoot", quantity: 16 },
          { id: 4, name: "Digital SLR", quantity: 20 },
          { id: 5, name: "Trail Cameras", quantity: 2 },
          { id: 6, name: "Underwater Digital", quantity: 4 },
          { id: 7, name: "Other Digital Cameras", quantity: 54 },
          { id: 8, name: "Video Cameras", quantity: 52 },
          { id: 9, name: "Camcorders", quantity: 2 },
          { id: 10, name: "Helmet & Action", quantity: 3 },
          { id: 11, name: "Pocket", quantity: 0 },
          { id: 12, name: "Professional", quantity: 32 },
          { id: 13, name: "Other Video Cameras", quantity: 14 },
          { id: 14, name: "Lenses & Filters", quantity: 358 },
          { id: 15, name: "Filters", quantity: 48 },
          { id: 16, name: "Lenses", quantity: 53 },
          { id: 17, name: "Parts & Accessories", quantity: 256 },
          { id: 18, name: "Telescopes & Optics", quantity: 21 },
          { id: 19, name: "Microscopes", quantity: 3 },
          { id: 20, name: "Rangefinders", quantity: 2 },
          { id: 21, name: "Telescopes", quantity: 2 },
          { id: 22, name: "Parts & Accessories", quantity: 0 },
          { id: 23, name: "Other Telescopes & Optics", quantity: 14 },
          { id: 24, name: "Bags & Cases", quantity: 24 },
          { id: 25, name: "Batteries & Chargers", quantity: 40 },
          { id: 26, name: "Film Cameras", quantity: 24 },
          { id: 27, name: "Flashes & Accessories", quantity: 48 },
          { id: 28, name: "Lighting & Studio", quantity: 92 },
          { id: 29, name: "Memory Cards & Readers", quantity: 7 },
          { id: 30, name: "Tripods & Stands", quantity: 40 },
          { id: 31, name: "Other Photo & Video", quantity: 233 },
          { id: 32, name: "Audio & Visual Accessories", quantity: 338 },
          { id: 33, name: "Batteries & Chargers", quantity: 211 },
          { id: 34, name: "Home Automation", quantity: 957 },
          { id: 35, name: "Home Entertainment", quantity: 480 },
          { id: 36, name: "Electronic Components & Equipment", quantity: 6137 },
          { id: 37, name: "Gadgets", quantity: 1384 },
          { id: 38, name: "Portable Audio & Visual", quantity: 758 },
          { id: 39, name: "Security & Surveillance", quantity: 901 },
          { id: 40, name: "Alarm Systems & Beams", quantity: 61 },
          { id: 41, name: "Biometric Security", quantity: 20 },
          { id: 42, name: "Bugs & Bug Detectors", quantity: 3 },
          { id: 43, name: "Cables & Adapters", quantity: 15 },
          { id: 44, name: "CCTV & CCTV Kits", quantity: 401 },
          { id: 45, name: "CCTV Processors & Switches", quantity: 0 },
          { id: 46, name: "DVRs & NVRs", quantity: 23 },
          { id: 47, name: "Parts & Accessories", quantity: 78 },
          { id: 48, name: "Security Monitors & Displays", quantity: 11 },
          { id: 49, name: "Surveillance Cameras", quantity: 215 },
          { id: 50, name: "Smoke & Heat Detectors", quantity: 0 },
          { id: 51, name: "Vehicle Surveillance", quantity: 1 },
          { id: 52, name: "Other Security & Surveillance", quantity: 68 },
          { id: 53, name: "TVs & Projectors", quantity: 274 },
          { id: 54, name: "Wholesale & Bulk Lots", quantity: 79 },
          { id: 55, name: "Other Electronics", quantity: 1215 },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Cell Phones & Accessories",
    subCategories: [
      {
        children: [
          { id: 1, name: "Cell Phones & Smartphones", quantity: 4657 },
          { id: 2, name: "Apple", quantity: 1790 },
          { id: 3, name: "Huawei", quantity: 313 },
          { id: 4, name: "Samsung", quantity: 4657 },
          { id: 5, name: "Xiaomi", quantity: 4657 },
          { id: 6, name: "Nokia", quantity: 4657 },
          { id: 7, name: "Other Smartphone Brands", quantity: 1198 },
          { id: 8, name: "Accessories", quantity: 4657 },
          { id: 9, name: "Smart Watches", quantity: 4657 },
          { id: 10, name: "Smart Watch Accessories", quantity: 4657 },
          { id: 11, name: "Parts", quantity: 4657 },
          { id: 12, name: "Prepaid & Contracts", quantity: 4657 },
          { id: 13, name: "Services", quantity: 4657 },
          { id: 14, name: "Wholesale & Bulk Lots", quantity: 4657 },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Jewellery & Gemstones",
    subCategories: [
      {
        children: [
          { id: 1, name: "Engagement & Wedding Jewellery", quantity: 278 },
          { id: 2, name: "Bridal Jewellery", quantity: 10 },
          { id: 3, name: "Engagement Rings", quantity: 62 },
          { id: 4, name: "Wedding Rings", quantity: 23 },
          { id: 5, name: "Other Engagement & Wedding", quantity: 183 },
          { id: 6, name: "Watches", quantity: 1137 },
          { id: 7, name: "Women's Watches", quantity: 140 },
          { id: 8, name: "Men's Watches", quantity: 381 },
          { id: 9, name: "Parts & Accessories", quantity: 392 },
          { id: 10, name: "Children's Watches", quantity: 6 },
          { id: 11, name: "Pocket Watches", quantity: 24 },
          { id: 12, name: "Rare & Collectable Watches", quantity: 33 },
          { id: 13, name: "Other Watches", quantity: 159 },
          { id: 14, name: "Artisanal Jewellery", quantity: 459 },
          { id: 15, name: "Children's Jewellery", quantity: 42 },
          { id: 16, name: "Ethnic & Tribal Jewellery", quantity: 14 },
          { id: 17, name: "Fashion Jewellery", quantity: 2645 },
          { id: 18, name: "Fine Jewellery", quantity: 1757 },
          { id: 19, name: "Anklets", quantity: 2 },
          { id: 20, name: "Bangles & Bracelets", quantity: 97 },
          { id: 21, name: "Body Jewellery", quantity: 2 },
          { id: 22, name: "Brooches", quantity: 32 },
          { id: 23, name: "Charms & Charm Bracelets", quantity: 226 },
          { id: 24, name: "Earrings", quantity: 312 },
          { id: 25, name: "Jewellery Sets", quantity: 16 },
          { id: 26, name: "Necklaces & Pendants", quantity: 461 },
          { id: 27, name: "Rings", quantity: 591 },
          { id: 28, name: "Toe Rings", quantity: 1 },
          { id: 29, name: "Other Fine Jewellery", quantity: 12 },
          { id: 30, name: "Jewellery Boxes & Storage", quantity: 31 },
          { id: 31, name: "Men's Jewellery", quantity: 240 },
          { id: 32, name: "Vintage & Antique Jewellery", quantity: 364 },
          { id: 33, name: "Tools & Equipment", quantity: 23 },
          { id: 34, name: "Wholesale & Bulk Lots", quantity: 12 },
        ],
      },
    ],
  },
  {
    id: 4,
    name: "Property",
    subCategories: [
      {
        children: [
          { id: 1, name: "Rooms for Rent", quantity: 0 },
          { id: 2, name: "Room mate & Accommodation wanted", quantity: 0 },
          { id: 3, name: "Houses for Rent", quantity: 0 },
          { id: 4, name: "Flats for Rent", quantity: 0 },
          { id: 5, name: "Houses & Flats for Sale", quantity: 0 },
          { id: 6, name: "Holiday Homes", quantity: 0 },
          { id: 7, name: "Land & Plots for Sale", quantity: 0 },
          { id: 8, name: "Car Parks & Storage", quantity: 0 },
          { id: 9, name: "Commercial Properties for Rent", quantity: 0 },
          { id: 10, name: "Commercial Properties for Sale", quantity: 0 },
          { id: 11, name: "Short Term Rentals", quantity: 0 },
          { id: 12, name: "Other Property types", quantity: 0 },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Home & Living",
    subCategories: [
      {
        children: [
          { id: 1, name: "Kitchen, Dining & Bar", quantity: 4378 },
          { id: 2, name: "Cookware", quantity: 173 },
          { id: 3, name: "Cutlery & Knives", quantity: 175 },
          { id: 4, name: "Bakeware", quantity: 870 },
          { id: 5, name: "Smoking Accessories", quantity: 1065 },
          { id: 6, name: "Bar Accessories", quantity: 191 },
          { id: 7, name: "Kitchen Tools", quantity: 585 },
          { id: 8, name: "Cooking Utensils", quantity: 93 },
          { id: 9, name: "Cups & Glasses", quantity: 290 },
          { id: 10, name: "Dinnerware & Serving Dishes", quantity: 195 },
          { id: 11, name: "Kitchen Storage & Organisation", quantity: 289 },
          { id: 12, name: "Tableware & Linen", quantity: 90 },
          { id: 13, name: "Water Coolers & Filters", quantity: 12 },
          { id: 14, name: "Wine Accessories", quantity: 19 },
          { id: 15, name: "Other Kitchen, Dining & Bar", quantity: 324 },
          { id: 16, name: "Home Appliances", quantity: 1153 },
          { id: 17, name: "Parts & Accessories", quantity: 161 },
          { id: 18, name: "Bed & Bath", quantity: 813 },
          { id: 19, name: "Home Security", quantity: 502 },
          { id: 20, name: "Home Decor", quantity: 1839 },
          { id: 21, name: "DIY & Tools", quantity: 1698 },
          { id: 22, name: "Laundry & Cleaning", quantity: 198 },
          { id: 23, name: "Lighting & Lamps", quantity: 3097 },
          { id: 24, name: "Flowers, Celebrations & Gifts", quantity: 1004 },
          { id: 25, name: "Wholesale & Bulk Lots", quantity: 104 },
          { id: 26, name: "Other Home & Living", quantity: 1075 },
          { id: 27, name: "Furniture", quantity: 740 },
        ],
      },
    ],
  },
  {
    id: 6,
    name: "Clothing, Shoes & Accessories",
    subCategories: [
      {
        children: [
          { id: 1, name: "Women", quantity: 8291 },
          { id: 2, name: "Clothing", quantity: 7208 },
          { id: 3, name: "Shoes", quantity: 572 },
          { id: 4, name: "Accessories", quantity: 510 },
          { id: 5, name: "Men", quantity: 9035 },
          { id: 6, name: "Clothing", quantity: 8682 },
          { id: 7, name: "Shoes", quantity: 138 },
          { id: 8, name: "Accessories", quantity: 213 },
          { id: 9, name: "Kids", quantity: 805 },
          { id: 10, name: "Girls", quantity: 73 },
          { id: 11, name: "Boys", quantity: 276 },
          {
            id: 12,
            name: "Other Kids' Clothing, Shoes & Accessories",
            quantity: 456,
          },
          { id: 13, name: "Sunglasses", quantity: 44 },
          { id: 14, name: "Wedding Apparel & Accessories", quantity: 121 },
          { id: 15, name: "Bridal Accessories", quantity: 10 },
          { id: 16, name: "Bridal Veils", quantity: 1 },
          { id: 17, name: "Bridesmaids' Dresses", quantity: 10 },
          { id: 18, name: "Girls' Dresses", quantity: 1 },
          { id: 19, name: "Groom & Grooms men", quantity: 1 },
          { id: 20, name: "Mother of the Bride", quantity: 0 },
          { id: 21, name: "Wedding Dresses", quantity: 15 },
          { id: 22, name: "Other Wedding Apparel & Accessories", quantity: 81 },
          { id: 23, name: "Costumes & Accessories", quantity: 65 },
          { id: 24, name: "Accessories", quantity: 17 },
          { id: 25, name: "Adult Costumes", quantity: 39 },
          { id: 26, name: "Children's Costumes", quantity: 6 },
          { id: 27, name: "Other Costumes & Accessories", quantity: 2 },
          { id: 28, name: "Cultural & Ethnic Clothing", quantity: 37 },
          { id: 29, name: "Africa", quantity: 33 },
          { id: 30, name: "Asia & Pacific Islands", quantity: 0 },
          { id: 31, name: "Europe", quantity: 0 },
          { id: 32, name: "India & Pakistan", quantity: 2 },
          { id: 33, name: "Middle East", quantity: 0 },
          { id: 34, name: "Other Cultural & Ethnic Clothing", quantity: 0 },
          { id: 35, name: "Dance wear & Dance Shoes", quantity: 5 },
          { id: 36, name: "Girls' Dance wear & Shoes", quantity: 0 },
          { id: 37, name: "Women's Dance wear & Shoes", quantity: 4 },
          { id: 38, name: "Shoe Racks & Organisers", quantity: 49 },
          { id: 39, name: "Umbrellas", quantity: 8 },
          {
            id: 40,
            name: "Other Clothing, Shoes & Accessories",
            quantity: 3791,
          },
        ],
      },
    ],
  },
  {
    id: 7,
    name: "Cars & Bikes",
    subCategories: [
      {
        name: "Cars",
        children: [
          { id: 1, name: "AC Cobra", quantity: 0 },
          { id: 2, name: "Abarth", quantity: 1 },
          { id: 3, name: "Alfa Romeo", quantity: 7 },
          { id: 4, name: "Aston Martin", quantity: 1 },
          { id: 5, name: "Audi", quantity: 158 },
          { id: 6, name: "BAW", quantity: 1 },
          { id: 7, name: "BMW", quantity: 324 },
          { id: 8, name: "Baic", quantity: 3 },
          { id: 9, name: "Bentley", quantity: 1 },
          { id: 10, name: "CAM", quantity: 0 },
          { id: 11, name: "CMC", quantity: 0 },
          { id: 12, name: "Cadillac", quantity: 0 },
          { id: 13, name: "Chana", quantity: 1 },
          { id: 14, name: "Changan", quantity: 0 },
          { id: 15, name: "Chery", quantity: 17 },
          { id: 16, name: "Chevrolet", quantity: 163 },
          { id: 17, name: "Chrysler", quantity: 6 },
          { id: 18, name: "Citroen", quantity: 13 },
          { id: 19, name: "Daewoo", quantity: 2 },
          { id: 20, name: "Daihatsu", quantity: 13 },
          { id: 21, name: "Datsun", quantity: 47 },
          { id: 22, name: "Dodge", quantity: 7 },
          { id: 23, name: "FAW1", quantity: 0 },
          { id: 24, name: "Ferrari", quantity: 1 },
          { id: 25, name: "Fiat", quantity: 32 },
          { id: 26, name: "Ford", quantity: 678 },
          { id: 27, name: "Foton", quantity: 1 },
          { id: 28, name: "Fuso", quantity: 0 },
          { id: 29, name: "GWM", quantity: 34 },
          { id: 30, name: "Geely", quantity: 1 },
          { id: 31, name: "Go Now", quantity: 0 },
          { id: 32, name: "Golden Journey", quantity: 0 },
          { id: 33, name: "Haval", quantity: 35 },
          { id: 34, name: "Hino", quantity: 0 },
          { id: 35, name: "Honda", quantity: 118 },
          { id: 36, name: "Hummer", quantity: 1 },
          { id: 37, name: "Hyundai", quantity: 540 },
          { id: 38, name: "Infiniti", quantity: 0 },
          { id: 39, name: "Isuzu", quantity: 127 },
          { id: 40, name: "Iveco", quantity: 1 },
          { id: 41, name: "JMC", quantity: 2 },
          { id: 42, name: "Jac", quantity: 3 },
          { id: 43, name: "Jaguar", quantity: 14 },
          { id: 44, name: "Jeep", quantity: 67 },
          { id: 45, name: "Jinbei", quantity: 0 },
          { id: 46, name: "KTM", quantity: 0 },
          { id: 47, name: "Kia", quantity: 283 },
          { id: 48, name: "Lada", quantity: 0 },
          { id: 49, name: "Lamborghini", quantity: 0 },
          { id: 50, name: "Lancia", quantity: 0 },
          { id: 51, name: "Land Rover", quantity: 71 },
          { id: 52, name: "Lexus", quantity: 13 },
          { id: 53, name: "Lotus", quantity: 0 },
          { id: 54, name: "MG", quantity: 2 },
          { id: 55, name: "Mahindra", quantity: 34 },
          { id: 56, name: "Mandarin", quantity: 0 },
          { id: 57, name: "Maserati1", quantity: 0 },
          { id: 58, name: "Maybach", quantity: 0 },
          { id: 59, name: "Mazda", quantity: 122 },
          { id: 60, name: "Mercedes-Benz", quantity: 328 },
          { id: 61, name: "Mini", quantity: 26 },
          { id: 62, name: "Mitsubishi", quantity: 60 },
          { id: 63, name: "Nissan", quantity: 410 },
          { id: 64, name: "Noble", quantity: 0 },
          { id: 65, name: "Opel", quantity: 94 },
          { id: 66, name: "Peugeot", quantity: 33 },
          { id: 67, name: "Porsche", quantity: 16 },
          { id: 68, name: "Proton", quantity: 1 },
          { id: 69, name: "Renault", quantity: 234 },
          { id: 70, name: "Rolls-Royce", quantity: 0 },
          { id: 71, name: "Rover", quantity: 0 },
          { id: 72, name: "SAIC", quantity: 0 },
          { id: 73, name: "Saab", quantity: 0 },
          { id: 74, name: "Seat", quantity: 2 },
          { id: 75, name: "Smart", quantity: 3 },
          { id: 76, name: "SsangYong", quantity: 2 },
          { id: 77, name: "Subaru", quantity: 12 },
          { id: 78, name: "Suzuki", quantity: 134 },
          { id: 79, name: "TVR", quantity: 0 },
          { id: 80, name: "Tata", quantity: 16 },
          { id: 81, name: "Toyota", quantity: 1 },
          { id: 82, name: "Volkswagen", quantity: 1 },
          { id: 83, name: "Volvo", quantity: 33 },
          { id: 84, name: "Other Cars", quantity: 24 },
        ],
      },
      {
        name: "Motorcycle’s",
        children: [
          { id: 1, name: "Adly bike", quantity: 0 },
          { id: 2, name: "Aeon bike", quantity: 2 },
          { id: 3, name: "Aprilia", quantity: 2 },
          { id: 4, name: "Arctic Cat bike", quantity: 0 },
          { id: 5, name: "Atul bike", quantity: 1 },
          { id: 6, name: "BMW", quantity: 66 },
          { id: 7, name: "BSI bike", quantity: 0 },
          { id: 8, name: "Bajaj", quantity: 2 },
          { id: 9, name: "Bashan", quantity: 4 },
          { id: 10, name: "Big Boy", quantity: 43 },
          { id: 11, name: "Bombardier", quantity: 1 },
          { id: 12, name: "Buell", quantity: 0 },
          { id: 13, name: "CFMoto", quantity: 2 },
          { id: 14, name: "CPI bike", quantity: 0 },
          { id: 15, name: "Cagiva", quantity: 0 },
          { id: 16, name: "Can-Am", quantity: 14 },
          { id: 17, name: "Cleveland", quantity: 1 },
          { id: 18, name: "Conti", quantity: 1 },
          { id: 19, name: "Crosby", quantity: 0 },
          { id: 20, name: "Custom bike", quantity: 0 },
          { id: 21, name: "DS bike", quantity: 0 },
          { id: 22, name: "Dazon", quantity: 0 },
          { id: 23, name: "Ducati", quantity: 5 },
          { id: 24, name: "Euro-Trac", quantity: 0 },
          { id: 25, name: "Goes bike", quantity: 0 },
          { id: 26, name: "Go moto", quantity: 9 },
          { id: 27, name: "Gravely", quantity: 0 },
          { id: 28, name: "Harley Davidson", quantity: 32 },
          { id: 29, name: "Hero bike", quantity: 0 },
          { id: 30, name: "Honda", quantity: 113 },
          { id: 31, name: "Hunter bike", quantity: 0 },
          { id: 32, name: "Husqvarna", quantity: 19 },
          { id: 33, name: "Hyosung", quantity: 3 },
          { id: 34, name: "Indian", quantity: 0 },
          { id: 35, name: "Jonway", quantity: 4 },
          { id: 36, name: "Jordan", quantity: 0 },
          { id: 37, name: "KTM", quantity: 83 },
          { id: 38, name: "Kawasaki", quantity: 75 },
          { id: 39, name: "Kazuma", quantity: 2 },
          { id: 40, name: "Krusty", quantity: 0 },
          { id: 41, name: "Kymco", quantity: 2 },
          { id: 42, name: "Linhai", quantity: 4 },
          { id: 43, name: "MV bike", quantity: 1 },
          { id: 44, name: "Masai bike", quantity: 0 },
          { id: 45, name: "Master bike", quantity: 0 },
          { id: 46, name: "Moto Guzzi", quantity: 1 },
          { id: 47, name: "No Limit bike", quantity: 0 },
          { id: 48, name: "Other bikes", quantity: 74 },
          { id: 49, name: "PGO bike", quantity: 0 },
          { id: 50, name: "Piaggio", quantity: 0 },
          { id: 51, name: "Polaris", quantity: 10 },
          { id: 52, name: "Puzey", quantity: 4 },
          { id: 53, name: "Regal", quantity: 0 },
          { id: 54, name: "Royal Enfield", quantity: 0 },
          { id: 55, name: "Sachs bike", quantity: 0 },
          { id: 56, name: "Sam", quantity: 1 },
          { id: 57, name: "Sherco", quantity: 1 },
          { id: 58, name: "Shineray", quantity: 0 },
          { id: 59, name: "Skygo", quantity: 0 },
          { id: 60, name: "Suzuki", quantity: 99 },
          { id: 61, name: "Sym", quantity: 12 },
          { id: 62, name: "TVS bike", quantity: 0 },
          { id: 63, name: "Triumph", quantity: 12 },
          { id: 64, name: "Ural bike", quantity: 0 },
          { id: 65, name: "Vespa", quantity: 2 },
          { id: 66, name: "Victory", quantity: 0 },
          { id: 67, name: "Vuka", quantity: 2 },
          { id: 68, name: "Yamaha", quantity: 121 },
          { id: 69, name: "Zongshen", quantity: 2 },
          { id: 70, name: "Zontes", quantity: 1 },
        ],
      },
    ],
  },
  {
    id: 8,
    name: "Car Parts & Accessories",
    subCategories: [
      {
        children: [
          { id: 1, name: "Parts & Accessories", quantity: 9062 },
          { id: 2, name: "Exterior & Accessories", quantity: 666 },
          { id: 3, name: "Lighting & Accessories", quantity: 875 },
          { id: 4, name: "Interior & Accessories", quantity: 1049 },
          { id: 5, name: "Air Flow & Fuel Delivery", quantity: 75 },
          { id: 6, name: "Auto Electrical", quantity: 155 },
          { id: 7, name: "Brakes", quantity: 41 },
          { id: 8, name: "Cooling & Heating", quantity: 140 },
          { id: 9, name: "Engines & Performance", quantity: 278 },
          { id: 10, name: "Exhaust & Emission", quantity: 28 },
          { id: 11, name: "Suspension & Steering", quantity: 442 },
          { id: 12, name: "Transmission & Drivetrain", quantity: 85 },
          { id: 13, name: "Other Parts & Accessories", quantity: 5223 },
          { id: 14, name: "Audio & Electronics", quantity: 617 },
          { id: 15, name: "Audio & Video", quantity: 334 },
          { id: 16, name: "Electronics", quantity: 97 },
          { id: 17, name: "Other Audio & Electronics", quantity: 186 },
          { id: 18, name: "Wheels & Tyres", quantity: 226 },
          { id: 19, name: "Tools & Maintenance", quantity: 648 },
          { id: 20, name: "Auto Tools & Kits", quantity: 386 },
          { id: 21, name: "Car Care", quantity: 153 },
          { id: 22, name: "Oil & Additives", quantity: 7 },
          { id: 23, name: "Restoration", quantity: 23 },
          { id: 24, name: "Safety & Security", quantity: 78 },
          { id: 25, name: "Memorabilia & Novelty", quantity: 213 },
          { id: 26, name: "Towing & Trailers", quantity: 65 },
          { id: 27, name: "Scrapyard & Salvage Parts", quantity: 18 },
        ],
      },
    ],
  },
  {
    id: 9,
    name: "Motorcycle Parts & Accessories",
    subCategories: [
      {
        children: [
          { id: 1, name: "Parts", quantity: 659 },
          { id: 2, name: "Air Intake & Fuel Delivery", quantity: 14 },
          { id: 3, name: "Batteries & Mounts", quantity: 47 },
          { id: 4, name: "Cooling Systems", quantity: 8 },
          { id: 5, name: "Engine & Drive Train", quantity: 90 },
          { id: 6, name: "Exhausts & Exhaust Systems", quantity: 20 },
          { id: 7, name: "Fuel Containers", quantity: 0 },
          { id: 8, name: "Guards", quantity: 33 },
          { id: 9, name: "Instruments & Gauges", quantity: 17 },
          { id: 10, name: "Handlebars, Mirrors & Controls", quantity: 77 },
          { id: 11, name: "Lights & Indicators", quantity: 135 },
          { id: 12, name: "Oils & Lubricants", quantity: 9 },
          { id: 13, name: "Seats & Backrests", quantity: 13 },
          { id: 14, name: "Stands", quantity: 2 },
          { id: 15, name: "Suspension", quantity: 0 },
          { id: 16, name: "Wheels, Tyres & Brakes", quantity: 17 },
          { id: 17, name: "Other Motorcycle Parts", quantity: 172 },
          { id: 18, name: "Accessories", quantity: 700 },
          { id: 19, name: "Bags & Luggage", quantity: 31 },
          { id: 20, name: "Clothing, Boots & Accessories", quantity: 300 },
          { id: 21, name: "Communication & Electronics", quantity: 13 },
          { id: 22, name: "Helmets & Protection", quantity: 131 },
          { id: 23, name: "Motorcycle Ramps", quantity: 0 },
          { id: 24, name: "Security", quantity: 34 },
          { id: 25, name: "Other Motorcycle Accessories", quantity: 188 },
        ],
      },
    ],
  },
  {
    id: 10,
    name: "Boats and Watercraft",
    subCategories: [
      {
        children: [
          { id: 1, name: "Canoes", quantity: 9 },
          { id: 2, name: "Kayaks", quantity: 0 },
          { id: 3, name: "Row Boats", quantity: 1 },
          { id: 4, name: "Fishing Boats", quantity: 1 },
          { id: 5, name: "Jet Skis", quantity: 0 },
          { id: 6, name: "Motor Boats", quantity: 0 },
          { id: 7, name: "Other Boats", quantity: 1 },
          { id: 8, name: "Sail Boats", quantity: 0 },
          { id: 9, name: "Speed Boats", quantity: 0 },
        ],
      },
    ],
  },
  {
    id: 11,
    name: "Caravans,Trucks & Buses",
    subCategories: [
      {
        children: [
          { id: 1, name: "Campers and Motorhomes", quantity: 14 },
          { id: 2, name: "Camping Trailers", quantity: 49 },
          { id: 3, name: "Caravans", quantity: 148 },
          { id: 4, name: "Box trucks", quantity: 79 },
          { id: 5, name: "Bullnose trucks", quantity: 3 },
          { id: 6, name: "Cattle body trucks", quantity: 5 },
          { id: 7, name: "Chassis cab trucks", quantity: 42 },
          { id: 8, name: "Cherry picker trucks", quantity: 3 },
          { id: 9, name: "Concrete mixer trucks", quantity: 16 },
          { id: 10, name: "Concrete pump truck", quantity: 1 },
          { id: 11, name: "Concrete spraying trucks", quantity: 0 },
          { id: 12, name: "Crane trucks", quantity: 24 },
          { id: 13, name: "Curtain side trucks", quantity: 37 },
          { id: 14, name: "Dropside trucks", quantity: 145 },
          { id: 15, name: "Fire trucks", quantity: 1 },
          { id: 16, name: "Flat deck", quantity: 9 },
          { id: 17, name: "Flatbed trucks", quantity: 25 },
          { id: 18, name: "Garbage trucks", quantity: 5 },
          { id: 19, name: "Gas cylinder trucks", quantity: 0 },
          { id: 20, name: "Glass carrier trucks", quantity: 0 },
          { id: 21, name: "Honey sucker trucks", quantity: 6 },
          { id: 22, name: "Hooklift trucks", quantity: 1 },
          { id: 23, name: "Hydraulic truck crane", quantity: 9 },
          { id: 24, name: "Lowbed", quantity: 0 },
          { id: 25, name: "Mass side trucks", quantity: 2 },
          { id: 26, name: "Other trucks", quantity: 92 },
          { id: 27, name: "Personnel carrier trucks", quantity: 4 },
          { id: 28, name: "Recovery trucks", quantity: 9 },
          { id: 29, name: "Refrigerated trucks", quantity: 29 },
          { id: 30, name: "Rigid truck", quantity: 2 },
          { id: 31, name: "Rollback trucks", quantity: 17 },
          { id: 32, name: "Skip bin loader trucks", quantity: 9 },
          { id: 33, name: "Tanker trucks", quantity: 14 },
          { id: 34, name: "Tipper trucks", quantity: 120 },
          { id: 35, name: "Tipping body", quantity: 0 },
          { id: 36, name: "Truck", quantity: 60 },
          { id: 37, name: "Truck accessories", quantity: 7 },
          { id: 38, name: "Truck bodies", quantity: 0 },
          { id: 39, name: "Truck spares and parts", quantity: 221 },
          { id: 40, name: "Truck-Tractor", quantity: 246 },
          { id: 41, name: "Water bowser", quantity: 24 },
          { id: 42, name: "Water sprinkler trucks", quantity: 2 },
        ],
      },
      {
        name: "Buses",
        children: [
          { id: 1, name: "7 seater", quantity: 1 },
          { id: 2, name: "10 seater", quantity: 0 },
          { id: 3, name: "14 seater", quantity: 1 },
          { id: 4, name: "16 seater", quantity: 8 },
          { id: 5, name: "20 seater", quantity: 1 },
          { id: 6, name: "22 seater", quantity: 16 },
          { id: 7, name: "23 seater", quantity: 2 },
          { id: 8, name: "26 seater", quantity: 0 },
          { id: 9, name: "27 seater", quantity: 0 },
          { id: 10, name: "28 seater", quantity: 1 },
          { id: 11, name: "32 seater", quantity: 2 },
          { id: 12, name: "38 seater", quantity: 1 },
          { id: 13, name: "40 seater", quantity: 0 },
          { id: 14, name: "48 seater", quantity: 0 },
          { id: 15, name: "50 seater", quantity: 0 },
          { id: 16, name: "56 seater", quantity: 0 },
          { id: 17, name: "60 seater", quantity: 3 },
          { id: 18, name: "63 seater", quantity: 1 },
          { id: 19, name: "65 seater", quantity: 4 },
          { id: 20, name: "70 seater", quantity: 1 },
          { id: 21, name: "75 seater", quantity: 0 },
          { id: 22, name: "Personal carrier", quantity: 0 },
        ],
      },
    ],
  },
  {
    id: 12,
    name: "Truck,Trailer & Bus Spares",
    subCategories: [
      {
        name: "Truck Spares and Parts",
        children: [
          { id: 1, name: "Axles", quantity: 9 },
          { id: 2, name: "Body", quantity: 45 },
          { id: 3, name: "Brake Systems", quantity: 3 },
          { id: 4, name: "Cab", quantity: 6 },
          { id: 5, name: "Clutches And Pedals", quantity: 1 },
          { id: 6, name: "Cooling Systems", quantity: 5 },
          { id: 7, name: "Electrical Systems", quantity: 18 },
          { id: 8, name: "Engines", quantity: 85 },
          { id: 9, name: "Exhaust Systems", quantity: 1 },
          { id: 10, name: "Fuel Systems", quantity: 30 },
          { id: 11, name: "Gearboxes", quantity: 3 },
          { id: 12, name: "Hubs and Wheels", quantity: 2 },
          { id: 13, name: "Propeller Shafts", quantity: 1 },
          { id: 14, name: "Seals and O-Rings", quantity: 0 },
          { id: 15, name: "Steering", quantity: 1 },
          { id: 16, name: "Suspension", quantity: 4 },
          { id: 17, name: "Tyres", quantity: 13 },
          { id: 18, name: "Undercarriages", quantity: 1 },
        ],
      },
      {
        name: "Trailer Spares and Parts",
        children: [
          { id: 1, name: "Brake Systems", quantity: 1 },
          { id: 2, name: "Electrical Systems", quantity: 2 },
          { id: 3, name: "Hubs and Wheels", quantity: 6 },
          { id: 4, name: "Suspension", quantity: 1 },
        ],
      },
      {
        name: "Bus Spares and Parts",
        children: [
          { id: 1, name: "Axles", quantity: 1 },
          { id: 2, name: "Body", quantity: 12 },
          { id: 3, name: "Brake Systems", quantity: 0 },
          { id: 4, name: "Clutches and Pedals", quantity: 0 },
          { id: 5, name: "Cooling Systems", quantity: 3 },
          { id: 6, name: "Electrical Systems", quantity: 3 },
          { id: 7, name: "Engines", quantity: 18 },
          { id: 8, name: "Exhaust Systems", quantity: 0 },
          { id: 9, name: "Fuel Systems", quantity: 2 },
          { id: 10, name: "Gearboxes", quantity: 4 },
          { id: 11, name: "Hubs and Wheels", quantity: 0 },
          { id: 12, name: "Propeller Shafts", quantity: 0 },
          { id: 13, name: "Steering", quantity: 0 },
          { id: 14, name: "Suspension", quantity: 0 },
        ],
      },
    ],
  },
  {
    id: 13,
    name: "All Trailers",
    subCategories: [
      {
        children: [
          { id: 1, name: "Acid tanker", quantity: 0 },
          { id: 2, name: "Advertise trailer", quantity: 0 },
          { id: 3, name: "Auger bulk trailer", quantity: 2 },
          { id: 4, name: "Bitumen tanker", quantity: 0 },
          { id: 5, name: "Bottom dumper", quantity: 0 },
          { id: 6, name: "Box body", quantity: 8 },
          { id: 7, name: "Box trailer", quantity: 0 },
          { id: 8, name: "Brick trailer", quantity: 2 },
          { id: 9, name: "Cane", quantity: 0 },
          { id: 10, name: "Car carrier", quantity: 9 },
          { id: 11, name: "Car trailer", quantity: 0 },
          { id: 12, name: "Cattle body", quantity: 5 },
          { id: 13, name: "Cattle trailer", quantity: 1 },
          { id: 14, name: "Close volume body", quantity: 2 },
          { id: 15, name: "Coil carrier", quantity: 0 },
          { id: 16, name: "Coldroom trailer", quantity: 0 },
          { id: 17, name: "Copelyn", quantity: 1 },
          { id: 18, name: "Crane trailer", quantity: 0 },
          { id: 19, name: "Curtain side", quantity: 5 },
          { id: 20, name: "Diesel bowser trailer", quantity: 2 },
          { id: 21, name: "Dolly", quantity: 0 },
          { id: 22, name: "Double axle", quantity: 8 },
          { id: 23, name: "Drawbar", quantity: 1 },
          { id: 24, name: "Dropside", quantity: 1 },
          { id: 25, name: "Dry bulk tanker", quantity: 1 },
          { id: 26, name: "Dry goods van", quantity: 0 },
          { id: 27, name: "End tipping", quantity: 38 },
          { id: 28, name: "Extendable", quantity: 0 },
          { id: 29, name: "Farm trailer", quantity: 0 },
          { id: 30, name: "Flat deck", quantity: 28 },
          { id: 31, name: "Flatdeck trailer", quantity: 1 },
          { id: 32, name: "Food truck trailer", quantity: 0 },
          { id: 33, name: "Fuel tanker", quantity: 40 },
          { id: 34, name: "Game trailer", quantity: 0 },
          { id: 35, name: "General purpose trailer", quantity: 0 },
          { id: 36, name: "Generator trailers", quantity: 0 },
          { id: 37, name: "Goose neck", quantity: 0 },
          { id: 38, name: "Grain carrier", quantity: 0 },
          { id: 39, name: "High sides", quantity: 1 },
          { id: 40, name: "Honey sucker", quantity: 0 },
          { id: 41, name: "Insulated body", quantity: 0 },
          { id: 42, name: "Insulated fridge unit", quantity: 2 },
          { id: 43, name: "Interlink", quantity: 2 },
          { id: 44, name: "LPG", quantity: 1 },
          { id: 45, name: "LPG tanker", quantity: 3 },
          { id: 46, name: "Light tower trailers", quantity: 4 },
          { id: 47, name: "Lowbed", quantity: 1 },
          { id: 48, name: "Luggage trailer", quantity: 3 },
          { id: 49, name: "Mass side", quantity: 1 },
          { id: 50, name: "Oil claded tanker", quantity: 1 },
          { id: 51, name: "Pantech", quantity: 0 },
          { id: 52, name: "Personal carrier", quantity: 1 },
          { id: 53, name: "Pup trailers", quantity: 0 },
          { id: 54, name: "Refrigerated trailer", quantity: 9 },
          { id: 55, name: "Sand sloper", quantity: 0 },
          { id: 56, name: "Side tipper", quantity: 41 },
          { id: 57, name: "Skeletal", quantity: 3 },
          { id: 58, name: "Slope deck", quantity: 1 },
          { id: 59, name: "Specialist vehicle", quantity: 2 },
          { id: 60, name: "Stainless steel tank", quantity: 1 },
          { id: 61, name: "Stainless steel trailer", quantity: 2 },
          { id: 62, name: "Stepdeck", quantity: 1 },
          { id: 63, name: "Superlink", quantity: 7 },
          { id: 64, name: "Tautliner", quantity: 26 },
          { id: 65, name: "Timber", quantity: 1 },
          { id: 66, name: "Tipper trucks", quantity: 0 },
          { id: 67, name: "Tipping bulk trailer", quantity: 6 },
          { id: 68, name: "Trailer spares", quantity: 6 },
          { id: 69, name: "Trailers", quantity: 42 },
          { id: 70, name: "Tri-Axle", quantity: 0 },
          { id: 71, name: "Tri-Axle trailers", quantity: 1 },
          { id: 72, name: "Walking floor", quantity: 0 },
          { id: 73, name: "Water bowser trailer", quantity: 0 },
          { id: 74, name: "Water tanker", quantity: 4 },
          { id: 75, name: "Well deck", quantity: 0 },
        ],
      },
    ],
  },
  {
    id: 14,
    name: "Antiques & Collectables",
    subCategories: [
      {
        name: "Antiques & Collectables",
        children: [
          { id: 1, name: "Advertising, Signage & Posters", quantity: 115 },
          { id: 2, name: "Africana", quantity: 261 },
          { id: 3, name: "Appliances, Tools & Accessories", quantity: 90 },
          { id: 4, name: "Architectural Antiques", quantity: 10 },
          { id: 5, name: "Atlases, Maps & Nautical Antiques", quantity: 77 },
          { id: 6, name: "Bar & Smoking", quantity: 401 },
          { id: 7, name: "Carpets, Rugs & Textiles", quantity: 121 },
          { id: 8, name: "Casino Memorabilia", quantity: 5 },
          { id: 9, name: "Chandeliers, Lamps & Lighting", quantity: 100 },
          { id: 10, name: "Clocks", quantity: 52 },
          { id: 11, name: "Crystal & Glassware", quantity: 579 },
          { id: 12, name: "Ethnic & Tribal Art", quantity: 23 },
          { id: 13, name: "Furniture", quantity: 199 },
          { id: 14, name: "Kitchenalia", quantity: 561 },
          { id: 15, name: "Liquor & Spirits", quantity: 15 },
          { id: 16, name: "Mandela Memorabilia", quantity: 7 },
          { id: 17, name: "Ornaments & Figurines", quantity: 761 },
          { id: 18, name: "Photography & Lenses", quantity: 143 },
          { id: 19, name: "Porcelain & Ceramics", quantity: 1468 },
          { id: 20, name: "Dutch Porcelain", quantity: 37 },
          { id: 21, name: "English Porcelain", quantity: 798 },
          { id: 22, name: "French Porcelain", quantity: 11 },
          { id: 23, name: "German Porcelain", quantity: 81 },
          { id: 24, name: "Italian Porcelain", quantity: 12 },
          { id: 25, name: "Oriental Porcelain", quantity: 124 },
          { id: 26, name: "South African Porcelain", quantity: 52 },
          { id: 27, name: "Earthenware & Ironstone", quantity: 7 },
          { id: 28, name: "Stoneware", quantity: 23 },
          { id: 29, name: "Other Porcelain & Ceramics", quantity: 320 },
          { id: 30, name: "Scientific Instruments", quantity: 38 },
          { id: 31, name: "Silver & Metal ware", quantity: 700 },
          { id: 32, name: "Stationery & Writing Equipment", quantity: 494 },
          { id: 33, name: "Telephones & Communication", quantity: 17 },
          { id: 34, name: "Transportation", quantity: 161 },
          { id: 35, name: "Other Antiques & Collectables", quantity: 1683 },
        ],
      },
      {
        name: "Militaria",
        children: [
          { id: 1, name: "Badges & Insignia", quantity: 862 },
          { id: 2, name: "Clothing & Equipment", quantity: 204 },
          { id: 3, name: "Medals", quantity: 175 },
          { id: 4, name: "Militaria Books & DVDs", quantity: 672 },
          { id: 5, name: "Sharp Edged Weaponry", quantity: 50 },
          { id: 6, name: "War Memorabilia", quantity: 159 },
          { id: 7, name: "Other Militaria", quantity: 157 },
        ],
      },
    ],
  },
  {
    id: 15,
    name: "Coins, Notes, Stamps",
    subCategories: [
      {
        name: "Coins,Notes,Stamps",
        children: [
          { id: 1, name: "Coins,Notes,Stamps", quantity: 0 },
          { id: 2, name: "Accessories", quantity: 85 },
          { id: 3, name: "Ancient & Shipwreck", quantity: 7 },
          { id: 4, name: "Bullion Bars", quantity: 1 },
          { id: 5, name: "Gold & Bullion Coins", quantity: 8 },
          { id: 6, name: "International Bank Notes", quantity: 626 },
          { id: 7, name: "International Coins", quantity: 1707 },
          { id: 8, name: "Kruger rands", quantity: 7 },
          { id: 9, name: "Mandela Coins", quantity: 30 },
          { id: 10, name: "Republic of South Africa Coins", quantity: 436 },
          { id: 11, name: "Half Cent", quantity: 13 },
          { id: 12, name: "One Cent", quantity: 30 },
          { id: 13, name: "Two Cent", quantity: 28 },
          { id: 14, name: "Two and a Half Cent", quantity: 9 },
          { id: 15, name: "Five Cent", quantity: 38 },
          { id: 16, name: "Ten Cent", quantity: 23 },
          { id: 17, name: "Twenty Cent", quantity: 26 },
          { id: 18, name: "Fifty Cent", quantity: 18 },
          { id: 19, name: "One Rand", quantity: 75 },
          { id: 20, name: "Two Rand", quantity: 23 },
          { id: 21, name: "Five Rand", quantity: 24 },
          { id: 22, name: "Gold Natura Series", quantity: 0 },
          { id: 23, name: "Gold Protea Series", quantity: 1 },
          {
            id: 24,
            name: "Special Circulation & Commemorative Coins",
            quantity: 40,
          },
          { id: 25, name: "Collections & Lots", quantity: 15 },
          { id: 26, name: "Proof Sets", quantity: 43 },
          {
            id: 27,
            name: "Other Republic of South Africa Coins",
            quantity: 23,
          },
          { id: 28, name: "South African Bank Notes", quantity: 175 },
          { id: 29, name: "Tokens & Medallions", quantity: 256 },
          { id: 30, name: "Union of South Africa Coins", quantity: 468 },
          { id: 31, name: "ZAR Bank Notes", quantity: 2 },
          { id: 32, name: "ZAR Coins", quantity: 161 },
          { id: 33, name: "Numismatic collectables", quantity: 80 },
        ],
      },
    ],
  },
  {
    id: 16,
    name: "Arts & Crafts",
    subCategories: [
      {
        children: [
          { id: 1, name: "Original South African Art", quantity: 415 },
          { id: 2, name: "Drawings", quantity: 19 },
          { id: 3, name: "Limited Edition Prints", quantity: 43 },
          { id: 4, name: "Paintings", quantity: 293 },
          { id: 5, name: "Photography", quantity: 2 },
          { id: 6, name: "Sculptures & Carvings", quantity: 23 },
          { id: 7, name: "Mixed Media & Collages", quantity: 12 },
          { id: 8, name: "Other Original South African Art", quantity: 19 },
          { id: 9, name: "Original International Art", quantity: 97 },
          { id: 10, name: "Art Directly From The Artist", quantity: 136 },
          { id: 11, name: "Reproduced Art", quantity: 137 },
          { id: 12, name: "Unknown Artist", quantity: 54 },
          { id: 13, name: "Other Artwork", quantity: 62 },
          { id: 14, name: "Finished Crafts", quantity: 82 },
          { id: 15, name: "Sewing & Fabric", quantity: 496 },
          { id: 16, name: "Art Supplies", quantity: 1016 },
          { id: 17, name: "Beading & Jewellery Making", quantity: 712 },
          { id: 18, name: "Needle Crafting", quantity: 232 },
          { id: 19, name: "Paper Crafts", quantity: 291 },
          { id: 20, name: "Home Crafts", quantity: 30 },
          { id: 21, name: "Mosaic Making & Glass Crafting", quantity: 135 },
          { id: 22, name: "Wholesale & Bulk Lots", quantity: 2 },
          { id: 23, name: "Other Crafts", quantity: 212 },
        ],
      },
    ],
  },
  {
    id: 17,
    name: "Books & Education",
    subCategories: [
      {
        children: [
          { id: 1, name: "Fiction", quantity: 6325 },
          { id: 2, name: "Non-Fiction", quantity: 14574 },
          { id: 3, name: "Antiquarian & Collectable", quantity: 1103 },
          { id: 4, name: "Textbooks & Educational", quantity: 1039 },
          { id: 5, name: "Children & Baby Books", quantity: 1574 },
          { id: 6, name: "Comics & Graphic Novels", quantity: 1238 },
          { id: 7, name: "Foreign Language Books", quantity: 259 },
          { id: 8, name: "Magazines", quantity: 279 },
          { id: 9, name: "Audio Books", quantity: 28 },
          { id: 10, name: "eBooks", quantity: 198 },
          { id: 11, name: "Book Accessories", quantity: 45 },
          { id: 12, name: "Wholesale & Bulk Lots", quantity: 5 },
        ],
      },
    ],
  },
  {
    id: 18,
    name: "Music & Instruments",
    subCategories: [
      {
        children: [
          { id: 1, name: "Instruments", quantity: 192 },
          { id: 2, name: "Music CDs", quantity: 8001 },
          { id: 3, name: "Music DVDs", quantity: 250 },
          { id: 4, name: "Music Memorabilia", quantity: 33 },
          { id: 5, name: "Sound, Light & Stage", quantity: 137 },
          { id: 6, name: "DJ Equipment", quantity: 35 },
          { id: 7, name: "Lighting & Stage", quantity: 15 },
          { id: 8, name: "Live Sound", quantity: 53 },
          { id: 9, name: "Recording & Studio", quantity: 25 },
          { id: 10, name: "Other Sound, Light & Stage", quantity: 6 },
          { id: 11, name: "Tapes, LPs & Other Formats", quantity: 4177 },
          { id: 12, name: "Other Music Related Items", quantity: 44 },
        ],
      },
    ],
  },
  {
    id: 19,
    name: "Holistic & Esoteric",
    subCategories: [
      {
        children: [
          { id: 1, name: "Aromatherapy", quantity: 53 },
          { id: 2, name: "Altar Supplies", quantity: 1 },
          { id: 3, name: "Astrology", quantity: 2 },
          { id: 4, name: "Books, Cards & Calendars", quantity: 20 },
          { id: 5, name: "Candles & Holders", quantity: 32 },
          { id: 6, name: "Chakras & Reiki", quantity: 3 },
          { id: 7, name: "Crystals, Gemstones & Stones", quantity: 74 },
          { id: 8, name: "Dream Catchers", quantity: 0 },
          { id: 9, name: "Deities, Statues & Plaques", quantity: 109 },
          { id: 10, name: "Divination", quantity: 1 },
          { id: 11, name: "Feng Shui", quantity: 3 },
          { id: 12, name: "Herbs, Seeds & Healing", quantity: 0 },
          { id: 13, name: "Jewellery & Accessories", quantity: 171 },
          { id: 14, name: "Music", quantity: 6 },
          { id: 15, name: "Pendulums", quantity: 1 },
          { id: 16, name: "Runes", quantity: 0 },
          { id: 17, name: "Services", quantity: 0 },
          { id: 18, name: "Other Holistic & Esoteric", quantity: 11 },
        ],
      },
    ],
  },
  {
    id: 20,
    name: "Movies & Television",
    subCategories: [
      {
        children: [
          { id: 1, name: "Movies", quantity: 3338 },
          { id: 2, name: "TV Series", quantity: 495 },
          { id: 3, name: "Memorabilia", quantity: 93 },
          { id: 4, name: "Collectable Figurines", quantity: 13 },
          { id: 5, name: "Collectable Signs", quantity: 39 },
          { id: 6, name: "Movie Props & Replicas", quantity: 1 },
          { id: 7, name: "Other Movie Memorabilia", quantity: 39 },
        ],
      },
    ],
  },
  {
    id: 21,
    name: "Garden, Patio & Pet Accessories",
    subCategories: [
      {
        children: [
          { id: 1, name: "Outdoor Lighting", quantity: 318 },
          { id: 2, name: "Garden & Patio Furniture", quantity: 96 },
          { id: 3, name: "Flowers, Trees & Plants", quantity: 946 },
          { id: 4, name: "Aquatic Plants", quantity: 3 },
          { id: 5, name: "Bonsai", quantity: 36 },
          { id: 6, name: "Cacti & Succulents", quantity: 189 },
          { id: 7, name: "Carnivorous Plants", quantity: 6 },
          { id: 8, name: "Cycads & Cycas", quantity: 0 },
          { id: 9, name: "Flowers", quantity: 228 },
          { id: 10, name: "Fruits", quantity: 14 },
          { id: 11, name: "Grasses", quantity: 4 },
          { id: 12, name: "Herbs", quantity: 21 },
          { id: 13, name: "Shrubs", quantity: 108 },
          { id: 14, name: "Trees", quantity: 66 },
          { id: 15, name: "Vegetables", quantity: 83 },
          { id: 16, name: "Vines", quantity: 12 },
          { id: 17, name: "Other Flowers, Trees & Plants", quantity: 171 },
          { id: 18, name: "Braai & Outdoor Cooking", quantity: 143 },
          { id: 19, name: "Braai’s", quantity: 23 },
          { id: 20, name: "Braai Covers", quantity: 0 },
          { id: 21, name: "Picnic Baskets & Backpacks", quantity: 3 },
          { id: 22, name: "Potjie", quantity: 0 },
          { id: 23, name: "Tools & Accessories", quantity: 89 },
          { id: 24, name: "Other Braai & Outdoor Cooking", quantity: 26 },
          { id: 25, name: "Outdoor Heating & Cooling", quantity: 1 },
          { id: 26, name: "Garden Decor", quantity: 53 },
          { id: 27, name: "Gardening & Supplies", quantity: 306 },
          { id: 28, name: "Swimming Pools & Hot Tubs", quantity: 209 },
          { id: 29, name: "Garden Tools", quantity: 55 },
          { id: 30, name: "Garden Structures & Shade", quantity: 20 },
          { id: 31, name: "Lawnmowers", quantity: 4 },
          { id: 32, name: "Ponds & Water Features", quantity: 30 },
          { id: 33, name: "Other Garden, Patio", quantity: 245 },
        ],
      },
    ],
  },
  {
    id: 22,
    name: "Toys & Hobbies",
    subCategories: [
      {
        children: [
          { id: 1, name: "Bicycles & Ride-ons", quantity: 24 },
          { id: 2, name: "Bikes, Scooters & Hover boards", quantity: 35 },
          { id: 3, name: "Die Casts", quantity: 1450 },
          { id: 4, name: "Models", quantity: 1430 },
          { id: 5, name: "Accessories, Parts & Displays", quantity: 20 },
          { id: 6, name: "Models & Kits", quantity: 948 },
          { id: 7, name: "Railway", quantity: 342 },
          { id: 8, name: "Aircraft & Spacecraft", quantity: 58 },
          { id: 9, name: "Cars & Trucks", quantity: 201 },
          { id: 10, name: "Figures & Animals", quantity: 25 },
          { id: 11, name: "Military", quantity: 171 },
          { id: 12, name: "Motorcycles", quantity: 6 },
          { id: 13, name: "Ships & Boats", quantity: 11 },
          { id: 14, name: "Architecture & Dioramas", quantity: 8 },
          { id: 15, name: "Tools & Supplies", quantity: 87 },
          { id: 16, name: "Other Models", quantity: 35 },
          { id: 17, name: "Radio Control", quantity: 2778 },
          { id: 18, name: "Drones", quantity: 103 },
          { id: 19, name: "Aeroplanes", quantity: 30 },
          { id: 20, name: "Helicopters", quantity: 10 },
          { id: 21, name: "Boats", quantity: 7 },
          { id: 22, name: "Cars", quantity: 71 },
          { id: 23, name: "Motorcycles", quantity: 0 },
          { id: 24, name: "Robots", quantity: 12 },
          { id: 25, name: "Trucks & Tanks", quantity: 7 },
          { id: 26, name: "Parts & Accessories", quantity: 2526 },
          { id: 27, name: "Other Radio Control", quantity: 9 },
          { id: 28, name: "Electronic & Interactive Toys", quantity: 69 },
          { id: 29, name: "LEGO & Building Toys", quantity: 406 },
          { id: 30, name: "Collectable Toys", quantity: 2425 },
          { id: 31, name: "Action Figures", quantity: 606 },
          { id: 32, name: "Board Games & Cards", quantity: 358 },
          { id: 33, name: "Pretend Playing", quantity: 82 },
          { id: 34, name: "Slot Cars & Tracks", quantity: 58 },
          { id: 35, name: "Dolls & Bears", quantity: 263 },
          { id: 36, name: "Educational Toys", quantity: 812 },
          { id: 37, name: "Vintage Toys", quantity: 149 },
          { id: 38, name: "Outdoor Toys & Structures", quantity: 50 },
          { id: 39, name: "Soft Toys", quantity: 194 },
          { id: 40, name: "Battery & Wind-up", quantity: 51 },
          { id: 41, name: "Kids' Furniture", quantity: 30 },
          { id: 42, name: "Puzzles", quantity: 231 },
          { id: 43, name: "Kids' Arts, Crafts & Stationery", quantity: 809 },
          { id: 44, name: "Musical Toys & Instruments", quantity: 236 },
          { id: 45, name: "Wooden Toys", quantity: 56 },
          { id: 46, name: "Desktop & Novelty", quantity: 95 },
          { id: 47, name: "Bath Toys", quantity: 2 },
          { id: 48, name: "Magic Tricks & Sets", quantity: 11 },
          { id: 49, name: "Wholesale & Bulk Lots", quantity: 3 },
          { id: 50, name: "Other Toys", quantity: 693 },
          { id: 51, name: "Other Hobbies", quantity: 70 },
        ],
      },
    ],
  },
  {
    id: 23,
    name: "Sport & Leisure",
    subCategories: [
      {
        children: [
          { id: 1, name: "Sportswear", quantity: 668 },
          { id: 2, name: "Sporting Memorabilia", quantity: 469 },
          { id: 3, name: "Sports Nutrition", quantity: 28 },
          { id: 4, name: "Activity, HR & GPS Watches", quantity: 116 },
          { id: 5, name: "Gym & Exercise", quantity: 331 },
          { id: 6, name: "Individual Sports", quantity: 1373 },
          { id: 7, name: "Team Sports", quantity: 511 },
          { id: 8, name: "Outdoors", quantity: 4231 },
          { id: 9, name: "Camping & Hiking", quantity: 1404 },
          { id: 10, name: "Fishing", quantity: 1162 },
          { id: 11, name: "Hunting & Shooting", quantity: 810 },
          { id: 12, name: "Equestrian", quantity: 19 },
          { id: 13, name: "Water Activities", quantity: 687 },
          { id: 14, name: "Other Outdoors", quantity: 148 },
          { id: 15, name: "Indoor Games", quantity: 21 },
          { id: 16, name: "Other Sport & Leisure", quantity: 628 },
        ],
      },
    ],
  },
  {
    id: 24,
    name: "Baby & Kids",
    subCategories: [
      {
        children: [
          { id: 1, name: "Baby Shower", quantity: 9 },
          { id: 2, name: "Bath Time & Grooming", quantity: 45 },
          { id: 3, name: "Books, Media & Keepsakes", quantity: 17 },
          { id: 4, name: "Changing & Potty", quantity: 49 },
          { id: 5, name: "Clothing", quantity: 294 },
          { id: 6, name: "Activity Gear", quantity: 24 },
          { id: 7, name: "Feeding & Nursing", quantity: 206 },
          { id: 8, name: "Nursery", quantity: 228 },
          { id: 9, name: "Health & Safety", quantity: 87 },
          { id: 10, name: "Toys", quantity: 157 },
          { id: 11, name: "Travel", quantity: 89 },
          { id: 12, name: "Wholesale & Bulk Lots", quantity: 0 },
          { id: 13, name: "Other Baby", quantity: 385 },
          { id: 14, name: "Kids Furniture", quantity: 87 },
        ],
      },
    ],
  },
  {
    id: 25,
    name: "Health & Beauty",
    subCategories: [
      {
        children: [
          { id: 1, name: "Hair Care, Shaving & Hair Removal", quantity: 293 },
          { id: 2, name: "Fragrances", quantity: 935 },
          { id: 3, name: "Medical, Mobility & Disability", quantity: 762 },
          { id: 4, name: "Makeup & Nail Care", quantity: 735 },
          { id: 5, name: "Hair Extensions & Weaves", quantity: 136 },
          { id: 6, name: "Health & Fitness", quantity: 151 },
          { id: 7, name: "Supplements & Nutrition", quantity: 203 },
          { id: 8, name: "Skin Care & Tanning", quantity: 350 },
          { id: 9, name: "Natural & Homeopathic Remedies", quantity: 264 },
          { id: 10, name: "Bath & Body", quantity: 179 },
          { id: 11, name: "Eye Care, Glasses & Lenses", quantity: 30 },
          { id: 12, name: "Oral Care", quantity: 92 },
          { id: 13, name: "Tattoos & Body Art", quantity: 24 },
          { id: 14, name: "Wholesale & Bulk Lots", quantity: 1 },
          { id: 15, name: "Other Health & Beauty", quantity: 881 },
        ],
      },
    ],
  },
  {
    id: 26,
    name: "Groceries & Household",
    subCategories: [
      {
        children: [
          { id: 1, name: "Beverages", quantity: 73 },
          { id: 2, name: "Liquor", quantity: 68 },
          { id: 3, name: "Bread & Bakery", quantity: 8 },
          { id: 4, name: "Household & Cleaning Supplies", quantity: 417 },
          { id: 5, name: "Dairy, Eggs & Milk", quantity: 21 },
          { id: 6, name: "Fruit & Vegetables", quantity: 2 },
          { id: 7, name: "Meat, Poultry & Fish", quantity: 5 },
          { id: 8, name: "Pantry", quantity: 376 },
          { id: 9, name: "Ready Meals", quantity: 2 },
          { id: 10, name: "Snacks, Chips & Sweets", quantity: 322 },
          { id: 11, name: "Sugar & Baking Supplies", quantity: 17 },
          { id: 12, name: "Other Groceries & Household", quantity: 26 },
        ],
      },
    ],
  },
  {
    id: 27,
    name: "Computers & Networking",
    subCategories: [
      {
        children: [
          { id: 1, name: "Laptops & Notebooks", quantity: 436 },
          { id: 2, name: "Apple Laptops", quantity: 34 },
          { id: 3, name: "Desktop & All-in-Ones", quantity: 247 },
          { id: 4, name: "Apple Desktops", quantity: 18 },
          { id: 5, name: "PC Desktops & All-in-Ones", quantity: 228 },
          { id: 6, name: "iPads, Tablets & e Readers", quantity: 282 },
          { id: 7, name: "Devices", quantity: 152 },
          { id: 8, name: "Accessories", quantity: 130 },
          { id: 9, name: "Cables & Adapters", quantity: 1198 },
          { id: 10, name: "Components", quantity: 1626 },
          { id: 11, name: "Desktop & Laptop Accessories", quantity: 2861 },
          { id: 12, name: "Domain Names", quantity: 4 },
          { id: 13, name: "Drives & Storage", quantity: 1073 },
          { id: 14, name: "Blank Discs & Cases", quantity: 48 },
          { id: 15, name: "Flash Memory Drives", quantity: 210 },
          { id: 16, name: "Hard Drives & Accessories", quantity: 586 },
          { id: 17, name: "Memory Cards", quantity: 60 },
          { id: 18, name: "Memory Card Readers & Adapters", quantity: 9 },
          { id: 19, name: "Optical Drives & Writers", quantity: 37 },
          { id: 20, name: "Other Drives & Storage", quantity: 120 },
          { id: 21, name: "Keyboard, Mice & Input", quantity: 1544 },
          { id: 22, name: "Monitors & Accessories", quantity: 152 },
          { id: 23, name: "Networking & Communication", quantity: 926 },
          {
            id: 24,
            name: "Printers, Scanners & Accessories",
            quantity: 1295,
          },
          { id: 25, name: "Servers & Components", quantity: 144 },
          { id: 26, name: "Software", quantity: 118 },
          { id: 27, name: "Vintage", quantity: 4 },
          { id: 28, name: "Warranties", quantity: 0 },
          { id: 29, name: "Other Computers & Networking", quantity: 1134 },
        ],
      },
    ],
  },
  {
    id: 28,
    name: "Gaming",
    subCategories: [
      {
        children: [
          { id: 1, name: "Accessories", quantity: 1180 },
          { id: 2, name: "Consoles", quantity: 65 },
          { id: 3, name: "PlayStation", quantity: 24 },
          { id: 4, name: "Xbox", quantity: 10 },
          { id: 5, name: "Nintendo", quantity: 10 },
          { id: 6, name: "Other Consoles", quantity: 19 },
          { id: 7, name: "Games", quantity: 7924 },
          { id: 8, name: "Merchandise", quantity: 254 },
          { id: 9, name: "Online Memberships & Credit", quantity: 8 },
          { id: 10, name: "Repairs & Services", quantity: 105 },
          { id: 11, name: "Retro Gaming", quantity: 17 },
          { id: 12, name: "Other Gaming", quantity: 57 },
        ],
      },
    ],
  },
  {
    id: 29,
    name: "Travel & Entertainment",
    subCategories: [
      {
        children: [
          { id: 1, name: "Travel", quantity: 11 },
          { id: 2, name: "Experiences", quantity: 1 },
          { id: 3, name: "Entertainment", quantity: 0 },
          { id: 4, name: "Luggage & Travel Bags", quantity: 292 },
          { id: 5, name: "Travel Accessories", quantity: 42 },
        ],
      },
    ],
  },
  {
    id: 30,
    name: "Live Animals",
    subCategories: [
      {
        children: [
          { id: 1, name: "Rabbits & Guinea Pigs", quantity: 33 },
          { id: 2, name: "Mice and Rodents", quantity: 4 },
          { id: 3, name: "Dog Breeders", quantity: 0 },
          { id: 4, name: "Dogs & Puppies", quantity: 0 },
          { id: 5, name: "Cats & Kittens", quantity: 0 },
          { id: 6, name: "Horses & Ponies", quantity: 0 },
          { id: 7, name: "Birds", quantity: 0 },
          { id: 8, name: "Fish", quantity: 0 },
          { id: 9, name: "Kennels & Cattery", quantity: 0 },
          { id: 10, name: "Reptiles", quantity: 0 },
          { id: 11, name: "Sheep", quantity: 0 },
          { id: 12, name: "Spiders & Insects", quantity: 0 },
          { id: 13, name: "Other Pets", quantity: 0 },
        ],
      },
    ],
  },
  {
    id: 31,
    name: "Business, Farming & Industry",
    subCategories: [
      {
        children: [
          { id: 1, name: "Businesses & Websites for Sale", quantity: 0 },
          { id: 2, name: "Construction", quantity: 1057 },
          { id: 3, name: "Electrical & Test Equipment", quantity: 291 },
          { id: 4, name: "Farming & Forestry", quantity: 787 },
          { id: 5, name: "Industrial Supply", quantity: 1073 },
          { id: 6, name: "Manufacturing & Metalworking", quantity: 377 },
          { id: 7, name: "Office", quantity: 1814 },
          { id: 8, name: "Postage & Packing Supplies", quantity: 31 },
          { id: 9, name: "Retail & Hospitality", quantity: 334 },
          { id: 10, name: "Tools", quantity: 7065 },
          { id: 11, name: "Air Tools & Compressors", quantity: 263 },
          { id: 12, name: "Hand Tools", quantity: 2595 },
          { id: 13, name: "Parts & Accessories", quantity: 410 },
          { id: 14, name: "Power Tools", quantity: 1663 },
          { id: 15, name: "Soldering", quantity: 131 },
          { id: 16, name: "Supplies", quantity: 317 },
          { id: 17, name: "Tool Boxes & Sets", quantity: 81 },
          { id: 18, name: "Other Tools", quantity: 1604 },
          { id: 19, name: "Wholesale & Bulk Lots", quantity: 31 },
          {
            id: 20,
            name: "Other Business, Farming & Industry",
            quantity: 504,
          },
        ],
      },
    ],
  },
  {
    id: 32,
    name: "Gift Vouchers & Coupons",
    subCategories: [
      {
        children: [
          { id: 1, name: "Entertainment", quantity: 2 },
          { id: 2, name: "Experiences", quantity: 0 },
          { id: 3, name: "Fashion", quantity: 1 },
          { id: 4, name: "Health & Beauty", quantity: 1 },
          { id: 5, name: "Home & Living", quantity: 3 },
          { id: 6, name: "Music", quantity: 0 },
          { id: 7, name: "Travel", quantity: 0 },
          { id: 8, name: "Other Gift Vouchers & Coupons", quantity: 2 },
          { id: 9, name: "Google Play", quantity: 0 },
          { id: 10, name: "PlayStation", quantity: 1 },
          { id: 11, name: "Xbox", quantity: 0 },
          { id: 12, name: "Showmax", quantity: 0 },
          { id: 13, name: "Kaspersky", quantity: 1 },
          { id: 14, name: "McAfee", quantity: 0 },
          { id: 15, name: "Microsoft", quantity: 0 },
          { id: 16, name: "Norton", quantity: 0 },
          { id: 17, name: "Steam", quantity: 0 },
          { id: 18, name: "Ticketmaster", quantity: 0 },
          { id: 19, name: "Uber", quantity: 0 },
          { id: 20, name: "Other Digital Vouchers", quantity: 2 },
        ],
      },
    ],
  },
];
